/* BaristaDelight – Bewertungen dynamisch laden (Entwurf 09/2026)
 * Quelle austauschbar: window.BDBewertungen.quellen.<name> muss liefern
 *   gesamt()            -> { anzahl, schnitt }                 (alle Bewertungen der Quelle)
 *   produkt(skus)       -> { anzahl, schnitt }                 (nur dieses Produkt)
 *   karten(skus, n)     -> [{ text, name, produkt, sterne, datum }]
 * Aktuell: Reviews.io (öffentliche Widget-API). Für Judge.me später eine Quelle "judgeme" ergänzen.
 */
(function () {
  if (window.BDBewertungen && window.BDBewertungen.quellen) return;
  var API = 'https://api.reviews.io';

  function holen(url) {
    return fetch(url, { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }
  function vorname(n) {
    n = (n || '').trim();
    if (!n || /^anonym/i.test(n)) return '';
    return n.split(/\s+/)[0];
  }

  var reviewsio = {
    store: null,
    _stats: null,
    stats: function () {
      if (!this._stats) {
        this._stats = holen(API + '/timeline/data?type=product_review&store=' + encodeURIComponent(this.store) + '&per_page=1')
          .then(function (d) {
            return {
              produkt: { anzahl: +d.stats.review_count || 0, schnitt: +d.stats.average_rating || 0 },
              shop: { anzahl: +d.storeStats.review_count || 0, schnitt: +d.storeStats.average_rating || 0 }
            };
          });
      }
      return this._stats;
    },
    gesamt: function () {
      return this.stats().then(function (s) {
        var n = s.produkt.anzahl + s.shop.anzahl;
        var summe = s.produkt.anzahl * s.produkt.schnitt + s.shop.anzahl * s.shop.schnitt;
        return { anzahl: n, schnitt: n ? summe / n : 0 };
      });
    },
    produkt: function (skus) {
      if (!skus || !skus.length) return Promise.resolve({ anzahl: 0, schnitt: 0 });
      return holen(API + '/product/rating-batch?store=' + encodeURIComponent(this.store) + '&sku=' + encodeURIComponent(skus.join(';')))
        .then(function (liste) {
          var n = 0, summe = 0;
          (liste || []).forEach(function (x) { n += +x.num_ratings || 0; summe += (+x.num_ratings || 0) * (+x.average_rating || 0); });
          return { anzahl: n, schnitt: n ? summe / n : 0 };
        });
    },
    karten: function (skus, anzahl, mindestens) {
      mindestens = mindestens || 1;
      var store = encodeURIComponent(this.store);
      var eigene = skus && skus.length
        ? holen(API + '/product/review?store=' + store + '&sku=' + encodeURIComponent(skus.join(';')) + '&per_page=50')
            .then(function (d) { return ((d.reviews && d.reviews.data) || []).map(function (r) {
              return { text: r.review, name: vorname(r.reviewer && r.reviewer.first_name), produkt: r.product && r.product.name, sku: r.sku, sterne: r.rating, datum: r.date_created, eigen: true };
            }); }).catch(function () { return []; })
        : Promise.resolve([]);
      var produkte = holen(API + '/timeline/data?type=product_review&store=' + store + '&per_page=60')
        .then(function (d) { return (d.timeline || []).map(function (t) { var s = t._source;
          return { text: s.comments, name: vorname(s.author), produkt: s.product_name, sku: s.sku, sterne: s.rating, datum: s.date_created };
        }); }).catch(function () { return []; });
      var shop = holen(API + '/merchant/latest?store=' + store + '&per_page=40')
        .then(function (d) { return (d.reviews || []).map(function (r) {
          return { text: r.comments, name: vorname(r.reviewer && r.reviewer.first_name), produkt: '', sterne: r.rating, datum: r.date_created };
        }); }).catch(function () { return []; });
      var aktiv = null;
      var skuListe = window.BDBewertungen.skuUrl ? holen(window.BDBewertungen.skuUrl).then(function (l) { aktiv = {}; l.forEach(function (x) { aktiv[x] = 1; }); }).catch(function () {}) : Promise.resolve();
      return Promise.all([eigene, produkte, shop, skuListe]).then(function (teile) {
        var gesehen = {}, aus = [];
        [].concat(teile[0], teile[1], teile[2]).forEach(function (k) {
          var t = (k.text || '').trim();
          if (t.length < 12 || gesehen[t] || (+k.sterne || 0) < mindestens) return;
          gesehen[t] = true; k.text = t; aus.push(k);
        });
        // Reihenfolge: eigenes Produkt, dann deutsch + aktives Produkt, dann mit Produktbezug, dann neueste
        function punkte(k) {
          var p = 0;
          if (k.eigen) p += 8;
          if (deutsch(k.text)) p += 4;
          if (k.sku && aktiv && aktiv[k.sku]) p += 2;
          if (k.produkt) p += 1;
          return p;
        }
        aus.sort(function (a, b) { return (punkte(b) - punkte(a)) || String(b.datum).localeCompare(String(a.datum)); });
        return aus.slice(0, anzahl || 12);
      });
    }
  };

  function sterneSvg(wert) {
    var w = Math.max(0, Math.min(5, +wert || 0)) * 20;
    return '<span class="bd-sterne" style="--w:' + w.toFixed(1) + '%" aria-hidden="true"><span></span></span>';
  }
  function deutsch(t) {
    var w = (' ' + (t || '').toLowerCase() + ' ').match(/ (und|der|die|das|ist|nicht|sehr|ich|mit|für|super|schnell|gut|danke|wie|auch|war) /g);
    return !!w && w.length >= 2;
  }
  function zahl(x, stellen) {
    return x.toLocaleString(document.documentElement.lang || 'de', { minimumFractionDigits: stellen, maximumFractionDigits: stellen });
  }
  function esc(t) { var d = document.createElement('div'); d.textContent = t || ''; return d.innerHTML; }

  function karussell(el, quelle) {
    var skus = (el.getAttribute('data-skus') || '').split(';').filter(Boolean);
    var t = JSON.parse(el.querySelector('[data-bd-texte]').textContent);
    var spur = el.querySelector('[data-bd-spur]');
    var punkte = el.querySelector('[data-bd-punkte]');
    var info = el.querySelector('[data-bd-info]');
    var hinweis = el.querySelector('[data-bd-hinweis]');
    var anzahl = +el.getAttribute('data-anzahl') || 12;

    var summe = skus.length && el.getAttribute('data-modus') === 'produkt' ? quelle.produkt(skus) : Promise.resolve(null);
    Promise.all([quelle.gesamt(), summe]).then(function (w) {
      var g = w[0], p = w[1];
      if (info && g.anzahl) info.innerHTML = sterneSvg(g.schnitt) + ' ' + esc(t.gesamt.replace('[schnitt]', zahl(g.schnitt, 1)).replace('[anzahl]', zahl(g.anzahl, 0)));
      var quelle_hinweis = el.querySelector('[data-bd-quelle-text]');
      if (quelle_hinweis && g.anzahl) { quelle_hinweis.textContent = t.quelle.replace('[anzahl]', zahl(g.anzahl, 0)); quelle_hinweis.parentNode.hidden = false; }
      document.querySelectorAll('[data-bd-bew-wert]').forEach(function (z) { z.textContent = zahl(g.schnitt, 1).replace(/^/, '') + ' / 5'; });
      document.querySelectorAll('[data-bd-bew-anzahl]').forEach(function (z) { z.textContent = t.kennzahl.replace('[anzahl]', zahl(g.anzahl, 0)); });
      if (hinweis && p && !p.anzahl) hinweis.hidden = false;
    }).catch(function () {});

    quelle.karten(skus, anzahl, +el.getAttribute('data-min-sterne') || 1).then(function (liste) {
      if (!liste.length) { el.hidden = true; return; }
      spur.innerHTML = liste.map(function (k) {
        var unter = [k.name, k.produkt].filter(Boolean).join(', ');
        return '<figure class="bd-bew-karte"><span class="bd-bew-sterne" role="img" aria-label="' + esc(t.sterne.replace('[n]', k.sterne)) + '">' + sterneSvg(k.sterne) + '</span>' +
          '<blockquote>' + esc(k.text) + '</blockquote>' + (unter ? '<figcaption>' + esc(unter) + '</figcaption>' : '') + '</figure>';
      }).join('');
      aufbauen();
    }).catch(function () { el.hidden = true; });

    function proAnsicht() { return window.matchMedia('(min-width: 990px)').matches ? 3 : 1; }
    function seiten() { return Math.max(1, Math.ceil(spur.children.length / proAnsicht())); }
    function aktuelle() { return Math.round(spur.scrollLeft / spur.clientWidth); }
    function gehe(i) {
      var n = seiten(); i = (i + n) % n;
      spur.scrollTo({ left: i * spur.clientWidth, behavior: 'smooth' });
    }
    function punkteZeichnen() {
      var n = seiten(), a = aktuelle(), h = '';
      for (var i = 0; i < n; i++) h += '<button type="button" class="bd-bew-punkt" aria-label="' + esc(t.seite.replace('[n]', i + 1)) + '"' + (i === a ? ' aria-current="true"' : '') + ' data-i="' + i + '"></button>';
      punkte.innerHTML = h;
    }
    function aufbauen() {
      punkteZeichnen();
      el.querySelector('[data-bd-zurueck]').onclick = function () { gehe(aktuelle() - 1); };
      el.querySelector('[data-bd-weiter]').onclick = function () { gehe(aktuelle() + 1); };
      punkte.onclick = function (e) { var b = e.target.closest('[data-i]'); if (b) gehe(+b.getAttribute('data-i')); };
      var warte;
      spur.addEventListener('scroll', function () { clearTimeout(warte); warte = setTimeout(punkteZeichnen, 80); });
      window.addEventListener('resize', punkteZeichnen);
    }
  }

  function sterneZeile(el, quelle) {
    var skus = (el.getAttribute('data-skus') || '').split(';').filter(Boolean);
    var t = JSON.parse(el.querySelector('[data-bd-texte]').textContent);
    // Neben dem Titel nur Bewertungen genau dieses Produkts; ohne solche ein Hinweis statt Sternen
    quelle.produkt(skus).then(function (p) {
      var text, sterne = el.querySelector('[data-bd-sterne]');
      if (p && p.anzahl) {
        text = t.produkt.replace('[schnitt]', zahl(p.schnitt, 1)).replace('[anzahl]', zahl(p.anzahl, 0));
        sterne.innerHTML = sterneSvg(p.schnitt);
        if (p.anzahl === 1 && t.mehrzahl) text = text.replace(t.mehrzahl, t.einzahl);
      } else {
        text = t.keine; sterne.innerHTML = ''; el.classList.add('bd-sterne-zeile--keine');
      }
      el.querySelector('[data-bd-text]').textContent = text;
      el.hidden = false;
    }).catch(function () {});
  }

  // Gesamtwert und Anzahl als Kennzahl (Über-uns-Seite)
  function kennzahl(el, quelle) {
    quelle.gesamt().then(function (g) {
      if (!g || !g.anzahl) { el.hidden = true; return; }
      el.querySelector('[data-bd-schnitt]').textContent = zahl(g.schnitt, 1);
      el.querySelector('[data-bd-anzahl]').textContent = zahl(g.anzahl, 0);
    }).catch(function () { el.hidden = true; });
  }

  window.BDBewertungen = {
    skuUrl: window.BDBewertungenSku || null,
    quellen: { reviewsio: reviewsio },
    start: function () {
      document.querySelectorAll('[data-bd-bewertungen]:not([data-bereit])').forEach(function (el) {
        el.setAttribute('data-bereit', '');
        var q = window.BDBewertungen.quellen[el.getAttribute('data-quelle')];
        if (!q) return;
        q.store = el.getAttribute('data-store');
        if (el.hasAttribute('data-bd-kennzahl')) kennzahl(el, q);
        else if (el.hasAttribute('data-bd-sterne-zeile')) sterneZeile(el, q); else karussell(el, q);
      });
    }
  };
  if (document.readyState !== 'loading') window.BDBewertungen.start();
  else document.addEventListener('DOMContentLoaded', window.BDBewertungen.start);
  document.addEventListener('shopify:section:load', window.BDBewertungen.start);
})();
